import {
    Box,
    Button,
    Flex,
    Grid,
    GridItem,
    Image,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalOverlay,
    Text,
} from '@chakra-ui/react';
import SuccessImage from 'assets/success_icon.svg';

export default function StoreCreationSuccessModal({
    isOpen,
    onClose,
    storeName,
    storeLink,
    proceedClicked,
}) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalCloseButton />
                <ModalBody py="10">
                    <Flex justifyContent="center" mb="2">
                        <Image src={SuccessImage} />
                    </Flex>
                    <Flex flexDir="column" mb="3">
                        <Text textAlign="center" fontSize="lg" fontWeight="bold" my="4">
                            Store Created Successfully
                        </Text>
                        <Box bg="#EAECF0" py="2" px="4" my="2" borderRadius="md">
                            <Grid templateColumns="repeat(3, 1fr)" my="2" gap={4}>
                                <GridItem colSpan={1}>Store Name:</GridItem>
                                <GridItem colSpan={2}>{storeName}</GridItem>
                            </Grid>
                            <Grid templateColumns="repeat(3, 1fr)" my="2" gap={4}>
                                <GridItem colSpan={1}>Store Link:</GridItem>
                                <GridItem colSpan={2}>{storeLink}</GridItem>
                            </Grid>
                        </Box>
                    </Flex>
                    <Button
                        bg="#1b3b5f"
                        w="full"
                        color="#fff"
                        _hover={{ bg: '#fff', color: '#1b3b5f', border: '1px solid #1b3b5f' }}
                        fontWeight="400"
                        onClick={proceedClicked}>
                        Proceed
                    </Button>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}
